import React from 'react';
import './Contact.css';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock, FaBriefcase, FaInstagram } from 'react-icons/fa';
import contactimg from '../assets/images/contact_image.png';
import SEO from '../SEO';

function Contact() {
    return (
        <React.Fragment>
            <SEO
                title="Contact JDS Hospitals | Visakhapatnam | Phone, Address & Email"
                description="Contact JDS Hospitals, Seethammadara, Visakhapatnam. Phone: 08912717711, 08914052667. Email: info@jdshospitals.com. Available 24/7 for emergencies."
                keywords="JDS Hospitals contact, JDS Hospitals phone number, JDS Hospitals address, hospital Visakhapatnam contact, Seethammadara hospital Vizag"
                path="/Contact"
            />
            <section className="contact-page" id="contact-section">
                <div className="contact-hero">
                    <div className="container">
                        <h1>Contact Us</h1>
                        <p>We're here to help you. Reach out to us for any inquiries, support, or feedback.</p>
                    </div>
                </div>

                <div className='container py-5'>
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="contact-wrapper">
                                <div className="row g-0">
                                    <div className="col-md-5 contact-image-container">
                                        <img src={contactimg} alt="Contact JDS" className="contact-img" />
                                        <div className="image-overlay"></div>
                                    </div>

                                    <div className="col-md-7 contact-details-container">
                                        <div className="contact-info-block">
                                            <div className="section-label">OUR OFFICE</div>
                                            <div className="contact-item">
                                                <div className="icon-box">
                                                    <FaMapMarkerAlt />
                                                </div>
                                                <div className="text-box">
                                                    <h5>Our Location</h5>
                                                    <p>JDS Hospital, Seethammadara, <br />Visakhapatnam – 530013</p>
                                                </div>
                                            </div>

                                            <div className="contact-item">
                                                <div className="icon-box">
                                                    <FaPhoneAlt />
                                                </div>
                                                <div className="text-box">
                                                    <h5>Phone Numbers</h5>
                                                    <p>08912717711, 08912551697, <br />08914052667</p>
                                                </div>
                                            </div>

                                            <div className="contact-item">
                                                <div className="icon-box">
                                                    <FaEnvelope />
                                                </div>
                                                <div className="text-box">
                                                    <h5>Email Address</h5>
                                                    <p>info@jdshospitals.com</p>
                                                </div>
                                            </div>

                                            <div className="contact-socials mt-4">
                                                <a href="https://www.instagram.com/jdshospitals/?hl=en" target="_blank" rel="noopener noreferrer" className="social-icon-link">
                                                    <FaInstagram /> Follow us on Instagram
                                                </a>
                                            </div>
                                        </div>

                                        <div className="contact-careers-block">
                                            <div className="careers-content">
                                                <div className="careers-icon">
                                                    <FaBriefcase />
                                                </div>
                                                <div className="careers-text">
                                                    <h5>CAREERS AT HOSPITAL</h5>
                                                    <p>Join our team of dedicated healthcare professionals.</p>
                                                </div>
                                            </div>
                                            <button className="careers-btn">Explore Job Openings</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default Contact;
